const styles = (theme) => ({
  dialogContent: {
    textAlign: 'left',
    marginBottom: theme.spacing.unit * 2,
  },
  dialogContentBottom: {
    marginTop: theme.spacing.unit * 2,
  },
  expansionPanelSummaryText: {
    fontWeight: 600,
  },
  expansionPanelDetails: {
    textAlign: 'left',
  },
  documentStyle: {
    color: theme.palette.text.dark,
    '& h4': {
      margin: 0,
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    '& >:first-child': {
      marginTop: 0,
    },
    '& >:last-child': {
      marginBottom: 0,
    },
  },
  expandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      borderRadius: '5px',
    },
  },
});

export default styles;
